import styled from 'styled-components';

export const TableStyled=styled.div`
    max-width:800px;
    width:100%;
    & .tit-table{
        padding-right: 10px;
        background-color:var(--color-rojo);
        color:#ffffff;
        padding:10px 15px;
        text-align:center;
        font-size:1rem;
        font-weight:bold;
    }
    & table{
        width: 100%;
        border:1px solid var(--color-azul);
        & thead{
            & th{
                background-color:var(--color-azul);
                color:#ffffff;
                padding:5px 5px;
                &:nth-child(even){
                    background-color:#000000;
                }
            }
        }
        & tbody{
            & tr{
                & td{
                    padding:5px;
                    color:var(--color-azul);

                    & .bg-red{
                        background-color: var(--color-rojo);
                        color:#ffffff;
                    }
                    & .bg-azul{
                        background-color: var(--color-azul);
                        color:#ffffff;
                    }

                    button{
                        border:0px;
                        padding:5px;
                        display: inline-block;
                        &:disabled{
                            cursor: auto;
                            background-color: #ccc;
                        }
                    }
                }
                &:nth-child(odd){
                    & td:nth-child(odd){
                        background-color:#EBECF0;
                    }
                    & td:nth-child(even){
                        background-color:#ffffff;
                    }
                    
                }
                &:nth-child(even){
                    & td:nth-child(odd){
                        background-color:#ffffff;
                    }
                    & td:nth-child(even){
                        background-color:#EBECF0;
                    }
                }
            }
        }
    }
`;